import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISelfEvaluationResource } from "../types/ISelfEvaluationResource";

export interface ISelfEvaluationDeleteMutationParameters {
    selfEvaluation: RelationalValue<ISelfEvaluationResource>;
}

export type ISelfEvaluationDeleteMutationResult = void;

export const selfEvaluationDeleteMutation: IApiMutationFunction<ISelfEvaluationDeleteMutationParameters> = ({
    selfEvaluation,
}) => ({
    method: "DELETE",
    url: `/self_evaluations/${mapRelationalValue(selfEvaluation)}`,
});

export const useSelfEvaluationDeleteMutation = createApiMutationHook<
    ISelfEvaluationDeleteMutationParameters,
    ISelfEvaluationDeleteMutationResult
>(selfEvaluationDeleteMutation);
